export default "__VITE_ASSET__BHZfrNGr__"